import React from "react";
import PropTypes from "prop-types";
import "./AxiomLoginForm.css";

export default class AxiomLoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.DISCLAIMER_STORAGE_KEY = "dataGovernanceConsentDate";
    this.state = {
      showDisclaimer: false,
      isConsentChecked: false,
      pendingLogin: null,
    };
    this.monitorLogo = (
      <svg
        className="login-form-logo"
        viewBox="0 0 69 32"
        style={{ height: this.props.loginLogoHeight }}
      >
        <path
          fill="#3a6d73"
          style={{ fill: "#3a6d73" }}
          d="M0 21.443h4.811v10.557h-4.811v-10.557z"
        ></path>
        <path
          fill="#4b8b93"
          style={{ fill: "#4b8b93" }}
          d="M13.361 10.471h4.811v21.512h-4.811v-21.512z"
        ></path>
        <path fill="#58a7b3" style={{ fill: "#58a7b3" }} d="M26.704 0h4.811v32h-4.811v-32z"></path>
        <path
          fill="#a55d26"
          style={{ fill: "#a55d26" }}
          d="M37.227 27.189h10.557v4.811h-10.557v-4.811z"
        ></path>
        <path
          fill="#ee7f22"
          style={{ fill: "#ee7f22" }}
          d="M37.227 13.586h21.512v4.811h-21.512v-4.811z"
        ></path>
        <path fill="#fecd06" style={{ fill: "#fecd06" }} d="M37.227 0h32v4.811h-32v-4.811z"></path>
      </svg>
    );
  }

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      // this.props.doLogin();
      this.handleNormalLogin();
    }
  };

  getTodayDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  hasAcceptedDisclaimerToday = () => {
    return (
      localStorage.getItem(this.DISCLAIMER_STORAGE_KEY) ===
      this.getTodayDate()
    );
  };

  handleNormalLogin = () => {
    if (this.hasAcceptedDisclaimerToday()) {
      this.props.doLogin();
      return;
    }
    this.setState({
      pendingLogin: {
        type: "NORMAL",
      },
      isConsentChecked: false,
      showDisclaimer: true,
    });
  };

  handleSSOLogin = (e, option) => {
    e.preventDefault();
    if (this.hasAcceptedDisclaimerToday()) {
      window.location.href = option.uri;
      return;
    }
    this.setState({
      pendingLogin: {
        type: "SSO",
        uri: option.uri,
      },
      isConsentChecked: false,
      showDisclaimer: true,
    });
  };

  handleAcceptDisclaimer = () => {
    const { isConsentChecked, pendingLogin } = this.state;
    if (!isConsentChecked || !pendingLogin) {
      return;
    }
    localStorage.setItem(
      this.DISCLAIMER_STORAGE_KEY,
      this.getTodayDate()
    );
    const loginToContinue = pendingLogin;
    this.setState(
      {
        showDisclaimer: false,
        isConsentChecked: false,
        pendingLogin: null,
      },
      () => {
        if (loginToContinue.type === "NORMAL") {
          this.props.doLogin();
          return;
        }
        if (
          loginToContinue.type === "SSO" &&
          loginToContinue.uri
        ) {
          window.location.href = loginToContinue.uri;
        }
      }
    );
  };

  handleDeclineDisclaimer = () => {
    this.setState({
      showDisclaimer: false,
      isConsentChecked: false,
      pendingLogin: null,
    });
  };

  render() {
    const {
      showDisclaimer,
      isConsentChecked
    } = this.state
    return (
      <div>
        {this.props.isMonitorLoginEnabled && (
          <div className="login-form">
            {this.props.includeAppLogo && this.props.appLogo ? (
              <img
                className="login-form-logo"
                src={this.props.appLogo}
                style={{ height: this.props.loginLogoHeight }}
              />
            ) : (
              this.monitorLogo
            )}
            {this.props.includeHeaderText && (
              <h1 className="login-form-header">{this.props.headerText}</h1>
            )}
            {this.props.includeSubHeaderText && (
              <h3 className="login-form-subheader">{this.props.subHeaderText}</h3>
            )}
            {this.props.forgotPasswordView ? (
              <>
                <div className="login-form-group">
                  <input
                    type="text"
                    className="login-form-control"
                    placeholder=" "
                    autoFocus={true}
                    onKeyPress={this.handleKeyPress}
                    onChange={(e) => this.props.onChange("email", e)}
                    value={this.props.email}
                  />
                  <label className={"login-form-label"}>Email</label>
                </div>
                <button onClick={this.props.sendPasswordLink} className="axiom-login-button">
                  SUBMIT
                </button>
                <div className="login-form-forgot-password" onClick={this.props.forgotPassword}>
                  LogIn
                </div>
              </>
            ) : (
              <>
                <div className="login-form-group">
                  <input
                    type="text"
                    className="login-form-control"
                    placeholder=" "
                    autoFocus={true}
                    onKeyPress={this.handleKeyPress}
                    onChange={(e) => this.props.onChange("email", e)}
                    value={this.props.email}
                  />
                  <label className={"login-form-label"}>Username</label>
                </div>
                <div className="login-form-group">
                  <input
                    type={this.props.showPassword ? "text" : "password"}
                    className="login-form-control"
                    placeholder=" "
                    onKeyPress={this.handleKeyPress}
                    onChange={(e) => this.props.onChange("password", e)}
                  />
                  <label className={"login-form-label"}>Password</label>
                  <label
                    className={"login-form-password-show-hide"}
                    onClick={(e) => this.props.onShowPasswordChange()}
                  >
                    {this.props.showPassword ? "Hide" : "Show"}
                  </label>
                </div>

                <div className="login-form-group login-form-remember-me-group">
                  <input
                    type="checkbox"
                    className="login-form-checkbox"
                    onChange={(e) => this.props.onRememberMeChange()}
                    defaultChecked={this.props.rememberMe}
                    id="login-form-remember-me-checkbox"
                  />
                  <label
                    htmlFor="login-form-remember-me-checkbox"
                    className={"login-form-label login-form-remember-me-label"}
                  >
                    Remember Me
                  </label>
                </div>
                {/* <button onClick={this.props.doLogin} className="axiom-login-button">
                  LOGIN
                </button> */}
                <button onClick={this.handleNormalLogin} className="axiom-login-button">
                  LOGIN
                </button>
                {!this.props.hideForgotPassword && (
                  <div className="login-form-forgot-password" onClick={this.props.forgotPassword}>
                    Forgot Password?
                  </div>
                )}
              </>
            )}
          </div>
        )}
        {!!this.props.loginOptions.length && (
          <div
            className={
              !!this.props.loginOptions.length && !this.props.isMonitorLoginEnabled
                ? "login-form-options only"
                : "login-form-options"
            }
          >
            {this.props.isMonitorLoginEnabled && !!this.props.loginOptions.length && (
              <div className="login-form-seprator">
                <span className="login-form-seprator-label">OR</span>
              </div>
            )}
            <p>Login With</p>
            <div className="login-form-option-wrapper">
              {this.props.loginOptions.map((option, index) => {
                return (
                  <a className="login-form-option" href={option.uri} key={index} onClick={(e) => this.handleSSOLogin(e.option)}>
                    <img className="login-form-option-icon" src={option.logo} />
                  </a>
                );
              })}
            </div>
          </div>
        )}
        {showDisclaimer && (
          <div
            className="governance-consent-overlay"
            role="presentation"
          >
            <div
              className="governance-consent-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="governance-consent-title"
            >
              <div className="governance-consent-header">
                <div className="governance-consent-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 3L4.5 6V11.5C4.5 16.1 7.7 20.2 12 21.3C16.3 20.2 19.5 16.1 19.5 11.5V6L12 3Z"
                      stroke="currentColor"
                      strokeWidth="1.7"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9 12L11 14L15.5 9.5"
                      stroke="currentColor"
                      strokeWidth="1.7"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="governance-consent-heading">
                  <h2 id="governance-consent-title">
                    Data Governance & Confidentiality Consent
                  </h2>
                  <p>
                    Please review and acknowledge the following requirements
                    before continuing.
                  </p>
                </div>
              </div>
              <div className="governance-consent-body">
                <section className="governance-section">
                  <div className="governance-section-title">
                    Declaration & Consent
                  </div>
                  <p className="governance-intro">
                    By logging into and using this application, I acknowledge
                    and agree that:
                  </p>
                  <ul className="governance-consent-list">
                    <li>
                      The information, reports, customer data, financial records,
                      and other banking information accessible through this
                      application are confidential and proprietary to the Bank.
                    </li>
                    <li>
                      I will access and use data strictly for authorized business
                      purposes and within the scope of my assigned role and
                      responsibilities.
                    </li>
                    <li>
                      I will not copy, download, share, transmit, disclose, or
                      distribute any customer or banking data to unauthorized
                      individuals, systems, external parties, or personal
                      devices.
                    </li>
                    <li>
                      I will comply with all applicable Data Governance,
                      Information Security, Privacy, and Regulatory policies of
                      the Bank.
                    </li>
                    <li>
                      I understand that customer information is sensitive and
                      must be protected from unauthorized access, misuse,
                      modification, or disclosure.
                    </li>
                    <li>
                      I will immediately report any suspected security incident,
                      data breach, unauthorized access, or misuse of information.
                    </li>
                    <li>
                      I acknowledge that all activities performed within this
                      application, including data access, queries, downloads, and
                      report generation, may be logged, monitored, and audited by
                      the Bank.
                    </li>
                    <li>
                      I understand that any misuse of banking data, customer
                      information, or system access may result in disciplinary
                      action, access revocation, legal proceedings, and
                      regulatory consequences.
                    </li>
                    <li>
                      I understand that my queries and activities are monitored
                      and can be tracked.
                    </li>
                  </ul>
                </section>
                <section className="governance-user-consent">
                  <div className="governance-user-consent-title">
                    User Consent
                  </div>
                  <label className="governance-checkbox-wrapper">
                    <input
                      type="checkbox"
                      checked={isConsentChecked}
                      onChange={(e) =>
                        this.setState({
                          isConsentChecked: e.target.checked,
                        })
                      }
                    />
                    <span className="governance-custom-checkbox">
                      <svg viewBox="0 0 12 10">
                        <path
                          d="M1 5L4.3 8.2L11 1"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <span className="governance-checkbox-text">
                      I have read, understood, and agree to comply with the
                      Bank&apos;s Data Governance, Information Security, and
                      Confidentiality requirements. I undertake not to misuse any
                      banking data, customer information, or confidential
                      business information accessed through this application.
                    </span>
                  </label>
                  <p className="governance-consent-note">
                    By clicking <strong>Accept & Continue</strong>, I provide my
                    consent to the above terms and conditions.
                  </p>
                </section>
              </div>
              <div className="governance-consent-footer">
                <button
                  type="button"
                  className="governance-decline-button"
                  onClick={this.handleDeclineDisclaimer}
                >
                  Decline
                </button>
                <button
                  type="button"
                  className="governance-accept-button"
                  disabled={!isConsentChecked}
                  onClick={this.handleAcceptDisclaimer}
                >
                  Accept & Continue
                  <svg viewBox="0 0 20 20" fill="none">
                    <path
                      d="M4 10H16M11 5L16 10L11 15"
                      stroke="currentColor"
                      strokeWidth="1.7"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
